<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>
                        <b>{{ $t('Admin.AddAdmin.Header') }}</b>
                    </h5>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                            <label for="title2"><b>{{ $t('Admin.AddAdmin.Name') }}</b></label>
                            <InputText :class="`${error.name ? 'p-invalid' : ''}`" type="text"
                                :placeholder="$t('Admin.AddAdmin.PlaceName')" id="title2" v-model="name"
                                @keydown.space="preventLeadingSpace"></InputText>
                            <div class="text-red">{{ error.name }}</div>
                        </div>
                    </div>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                            <label for="title2"><b>{{ $t('Admin.AddAdmin.Email') }}</b></label>
                            <InputText :class="`${error.email ? 'p-invalid' : ''}`" type="text"
                                :placeholder="$t('Admin.AddAdmin.PlaceEmail')" id="title2" v-model="email"
                                @keydown.space="preventLeadingSpace"></InputText>
                            <div class="text-red">{{ error.email }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                            <label for="title2"><b>{{ $t('Admin.AddAdmin.Phone') }}</b></label>
                            <InputText :class="`${error.phone ? 'p-invalid' : ''}`" type="text"
                                :placeholder="$t('Admin.AddAdmin.PlacePhone')" id="title2" v-model="phone"
                                onkeypress="return /[0-9]/i.test(event.key)" maxlength="11"
                                @keydown.space="preventLeadingSpace"></InputText>
                            <div class="text-red">{{ error.phone }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                            <label for="top_10"><b>{{ $t('Admin.AddAdmin.Menuauthorization') }}</b></label>
                            <br />
                            <!-- <Dropdown v-model="dropdownValue" modelValue="dropdownValues[0].name" :options="dropdownValues" optionLabel="code" :placeholder="status" /> -->
                            <div :class="`${error.menus ? 'p-invalid' : ''}`" id="accesscheck">
                                <div>
                                    <input type="checkbox" id="MS" value="2" name="MS" v-model="menus" />
                                    <label for="2">{{ $t('Admin.AddAdmin.Menu1') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="MM" name="MM" value="3" v-model="menus" />
                                    <label for="3">{{ $t('Admin.AddAdmin.Menu2') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="PM" value="4" name="PM" v-model="menus" />
                                    <label for="4">{{ $t('Admin.AddAdmin.Menu3') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="PPM" name="PPM" value="5" v-model="menus" />
                                    <label for="5">{{ $t('Admin.AddAdmin.Menu4') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="BBM" value="6" name="BBM" v-model="menus" />
                                    <label for="6">{{ $t('Admin.AddAdmin.Menu5') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="Info" name="Info" value="7" v-model="menus" />
                                    <label for="7">{{ $t('Admin.AddAdmin.Menu6') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="LC" value="8" name="LC" v-model="menus" />
                                    <label for="8">{{ $t('Admin.AddAdmin.Menu7') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="LC" value="9" name="LC" v-model="menus" />
                                    <label for="8">{{ $t('Admin.AddAdmin.Menu8') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="LC" value="10" name="LC" v-model="menus" />
                                    <label for="8">{{ $t('Admin.AddAdmin.Menu9') }}</label>
                                </div>
                            </div>
                            <div class="text-red">{{ error.menus }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left; margin-top: -8px;">
                <Button :label="$t('Admin.AddAdmin.Save')" icon="pi pi-check" iconPos="left" class="p-button Black"
                    @click="AddAdmin" style="margin-top: -20px"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right;margin-top: -8px;">
                <Button :label="$t('Admin.AddAdmin.Back')" icon="pi pi-replay" iconPos="left"
                    class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)"
                    style="margin-top: -20px; background: white;color: black;"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center">
                <div></div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
// import { useRoute } from 'vue-router';
import AdminService from '../../service/API/AdminService';
import validateCreateAdmin from '../../validations/AdminManagement/validateCreateAdmin';
export default {
    name: 'AddAdmin',
    // props: ['dog', 'image'],
    data() {
        return {
            render1: false,
            render2: false,
            name: '',
            email: '',
            phone: '',
            menus: [],

            formData: new FormData(),
            error: {},
        };
    },
    created() {
        this.adminService = new AdminService();
    },
    mounted() {
        // const route = useRoute();
    },
    methods: {
        reinitialize() {
            (this.name = null), (this.email = null), (this.phone = null), (this.menus = null);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, "");
        },
        async AddAdmin() {
              let vcheckData = {
                  //     category_id: this.category_id.toString(),
                  name: this.name,
                  email: this.email,
                  phone: this.phone,
                  menus: this.menus.toString(),
                  //     top_10: this.top_10,
                  //     state: this.status,
                  //     // type: this.dropdownValueType == null ? '' : 'something',
              };
              const { isInvalid, error } = validateCreateAdmin(vcheckData);
              if (isInvalid) {
                  this.error = error;
              } else {
                  try {
                    const url = '/api/v1/admin/user/admin-add';
                    return await axios.post(url, { name: this.name, email: this.email, phone: this.phone, menus: this.menus.toString() }).then(() => {
                    // alert('성공적으로 저장');
                    this.$router.push({ name: 'Admin Management' });
                    setTimeout(() => {
                        this.$toast.add({ severity: 'success', summary: '확인됨', detail: '계정 생성 성공', life: 3000 });
                    }, 500);
                });
                  } catch(error){
                    let getError = error.response.data
                    console.log(getError.error)
                    if(getError.error == 'PhoneAlreadyExists'){
                        let errorText = '이미 존재하는 전화번호 입니다'
                        this.$toast.add({ severity: 'error', summary: '확인됨', detail: errorText, life: 3000 });
                    } else if(getError.error == 'emailAlreadyExists'){
                        let errorText = '이미 존재하는 이메일 입니다'
                        this.$toast.add({ severity: 'error', summary: '확인됨', detail: errorText, life: 3000 });
                    }
                  }
              }
          },

        // AddAdmin() {
        //     let vcheckData = {
        //         //     category_id: this.category_id.toString(),
        //         name: this.name,
        //         email: this.email,
        //         phone: this.phone,
        //         menus: this.menus.toString(),
        //         //     top_10: this.top_10,
        //         //     state: this.status,
        //         //     // type: this.dropdownValueType == null ? '' : 'something',
        //     };
        //     const { isInvalid, error } = validateCreateAdmin(vcheckData);
        //     if (isInvalid) {
        //         this.error = error;
        //         console.log(error);
        //     } else {
        //         console.log(this.formData);
        //         return axios.post('/api/v1/admin/user/admin-add', { name: this.name, email: this.email, phone: this.phone, menus: this.menus.toString() }).then((response) => {
        //             // alert('성공적으로 저장');
        //             console.log(response)
        //             // if (response.status === '400') {
        //             //     alert('Phone Number Already Exist');
        //             //     // this.error = ''
        //             // }
        //             // else {
        //                 this.$router.push({ name: 'Admin Management' });
        //                 setTimeout(() => {
        //                     this.$toast.add({ severity: 'success', summary: '확인됨', detail: '계정 생성 성공', life: 3000 });
        //                 }, 500);
        //             // }
        //         });
        //     }
        // },
    },
};
</script>

<style scoped>
.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}

.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}

.SelectBtn {
    max-width: 100px;
}

.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.p-button {
    background: #000000;
    border: 1px solid #0a0a0a;
    color: white;
}

div#accesscheck {
    margin-top: 10px;
    line-height: 30px;
}

button.p-button.p-component.p-button.Black {
    background: black;
    color: white;
}
.card{
    height: 100%;
}
</style>
